import { render, staticRenderFns } from "./InvoicePopup.vue?vue&type=template&id=42570a1a&scoped=true"
import script from "./InvoicePopup.vue?vue&type=script&lang=js"
export * from "./InvoicePopup.vue?vue&type=script&lang=js"
import style0 from "./InvoicePopup.vue?vue&type=style&index=0&id=42570a1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42570a1a",
  null
  
)

export default component.exports